import React, { useEffect, useState } from 'react';
import GeoBrandLogo from '../../geo/components/GeoBrandLogo';
import { resolveCompanyBrand } from '../../../utils/companyBrandLogos';

function getSourceDomain(url) {
  try {
    return new URL(String(url).trim()).hostname.replace(/^www\./i, '');
  } catch {
    return null;
  }
}

function NewsPrDrawerCreative({ imageURL, headline }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [imageURL]);

  if (!imageURL || failed) {
    return <div className="mi-detail-creative-empty">No preview available for this article.</div>;
  }

  return (
    <img
      className="news-pr-drawer-card__image"
      src={imageURL}
      alt={headline ? `Preview: ${headline}` : 'Article preview'}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}

export default function NewsPrDrawerCard({ row }) {
  const sourceDomain = getSourceDomain(row.landingPageUrl);
  const companyRaw = String(row.company || '').trim();
  const brand = companyRaw ? resolveCompanyBrand(companyRaw, {}) : null;

  return (
    <div className="social-post-card news-pr-drawer-card">
      <div className="news-pr-drawer-card__source">
        <div className="news-pr-drawer-card__source-top">
          {brand ? (
            <GeoBrandLogo
              name={brand.displayName}
              color={brand.color}
              logoUrl={brand.logoUrl}
              isClient={brand.isClient}
            />
          ) : null}
          {brand ? (
            <div className="news-pr-drawer-card__source-name" title={companyRaw}>
              {brand.displayName}
            </div>
          ) : null}
        </div>
        {sourceDomain ? (
          <span className="news-pr-drawer-card__url" title={row.landingPageUrl}>
            {sourceDomain}
          </span>
        ) : null}
      </div>

      {row.headline ? (
        <h3 className="news-pr-drawer-card__headline">{row.headline}</h3>
      ) : null}

      <div className="news-pr-drawer-card__creative">
        <NewsPrDrawerCreative imageURL={row.imageURL} headline={row.headline} />
      </div>

      {row.introText ? (
        <div className="news-pr-drawer-card__summary">{row.introText}</div>
      ) : null}
    </div>
  );
}
